module.exports = __webpack_public_path__ + "static/media/logo.54f6c10a.png";